import { useEffect, useState, useContext, useCallback } from 'react';
import './styles.css';
import ORBApi from '../../services/ORBApi';
import { getTranslatedTexts } from '../../utils/TranslationUtils';
import ORBNavBar from '../../components/common/ORBNavBar';
import { DistributionsTable } from './components/Tables';
import { NewDistributionPanel } from './components/Panels';
import ActionBar, { defaultFilters } from './components/ActionBar';
import { Modal } from '@mui/material';
import Backdrop from '@mui/material/Backdrop';
import Loading from '../../components/common/Loading';
import SessionContext from '../../contexts/SessionContext';
import config from '../../config';

export default function DistributionsTracks() {
  const [data, setData] = useState({
    pages: 0,
    current_page: 0,
    total_items: 0,
    distributions: [],
  });
  const [filters, setFilters] = useState(defaultFilters);
  const [order, setOrder] = useState('desc');
  const [orderBy, setOrderBy] = useState('reference_date');
  const [loading, setLoading] = useState(0);
  const [showAddForm, setShowAddForm] = useState(false);
  const [distributionOnPlay, setDistributionOnPlay] = useState(null);
  const {
    hasRole,
    session_data: { language_preference },
  } = useContext(SessionContext);

  const [texts, setTexts] = useState(null);

  const onFilterChange = (newFilters) => {
    setFilters({
      name: newFilters.name,
      status: newFilters.status,
      reference_date: newFilters.reference_date,
    });
  };

 const loadDistributions = useCallback((page) => {
    setLoading(1);
    ORBApi.loadDistributions(page, filters, config.default_page_size, orderBy, order)
      .then((data) => {
        setData(data);
      })
      .finally(() => setLoading(0));
  }, [filters.name, filters.status, filters.reference_date, orderBy, order]);

  const onDistributionsTableClick = (distribution) => {
    setDistributionOnPlay(distribution);
    setShowAddForm(true);
  };

  const onModalClose = () => {
    setShowAddForm(false);
    setDistributionOnPlay(null);
  };

  const onSaveHandler = () => {
    onModalClose();
    loadDistributions(data.current_page);
  };

  useEffect(() => {
    loadDistributions(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadDistributions]);

  useEffect(() => {
    setLoading(true);
    const translatedTexts = getTranslatedTexts(
      'distributions',
      language_preference,
    );
    setTexts(translatedTexts);
    setLoading(false);
  }, [language_preference]);

  return (
    <>
      <ORBNavBar
        page_title={texts?.title || ''}
        selectedOption="drop_distributions"
      />
      <ActionBar
        setFormVisible={setShowAddForm}
        total_items={data?.total_items}
        onFilterChange={onFilterChange}
      />

      {loading ? (
        <Loading
          className="labels-loading-container"
          text="Buscando Distribuições..."
        />
      ) : (
        <DistributionsTable
          hasRole={hasRole}
          data={data}
          messages={texts ? texts.messages : {}}
          headers_table={texts ? texts.headers_table : []}
          approve_distribution={texts ? texts.approve_distribution : {}}
          onPageChange={loadDistributions}
          onClick={onDistributionsTableClick}
          onSortChange={(newOrderBy, newOrder) => {
            setOrderBy(newOrderBy);
            setOrder(newOrder);
            loadDistributions(1);
          }}
          order={order}
          orderBy={orderBy}
        />
      )}

      {/* New distribution modal form */}
      {showAddForm && (
        <Modal
          slotsbackdropprops={Backdrop}
          slotsbackdropprops={{ timeout: 500 }}
          open={showAddForm}
          onClose={onModalClose}
        >
          <div>
            <NewDistributionPanel
              messages={texts ? texts.messages : {}}
              texts={texts}
              onSave={onSaveHandler}
              distribution={distributionOnPlay}
            />
          </div>
        </Modal>
      )}
    </>
  );
}
